import apiPath from '../../../config/api';

const DailySumPath = {
    title: "Toko Teknik - Laporan Rekap Penjualan",
    basePath: "/technique/rekap-penjualan",
    base: apiPath.retailDailySum,
}

export default DailySumPath;
